// Dependencias
import Api from '@/services/Api'
// methods
export default {
  verifyCompany (params) {
    return Api().post('vc', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/xMiscService.js